"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides helper methods for configuration.
 */
const ConfigHelper = {
    /**
     * Parse a string into a boolean.
     * @param value
     * @param defaultValue
     * @param returnEmptyDefault
     */
    toBoolean(value, defaultValue, returnEmptyDefault = false) {
        return value
            ? (value === null || value === void 0 ? void 0 : value.toLowerCase().trim()) === 'true'
            : defaultValue !== null && defaultValue !== void 0 ? defaultValue : (returnEmptyDefault ? defaultValue : false);
    },
    /**
     * Parse a string into a number.
     * @param value
     * @param defaultValue
     * @param returnEmptyDefault
     */
    toNumber(value, defaultValue, returnEmptyDefault = false) {
        return value
            ? Number.parseFloat(value)
            : defaultValue !== null && defaultValue !== void 0 ? defaultValue : (returnEmptyDefault ? defaultValue : 0);
    }
};
exports.default = ConfigHelper;
//# sourceMappingURL=ConfigHelper.js.map